let exportUrl = '';
let arr = [];
if (location.hostname != 'localhost') {
    arr = location.hostname.split('.');
    arr[0] = arr[0] + '-back';
    exportUrl = arr.join('.');
    exportUrl = 'http://' + exportUrl
} else {
    // exportUrl = 'http://ad-beta-back.pblab.com';
    exportUrl = 'http://www.adv.com';
    // exportUrl = 'http://ad.mulaitek.cn';
}
export default exportUrl
